import React, { useState, useEffect, useContext } from 'react';
import { UserOrderContext } from '../../../context/context';
import { useSelector, useDispatch } from 'react-redux';
import ProductStatesModule from './ProductStatesModule';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
import {
  showCustomizationModalAction,
  addItemToCartAction,
  setUserLastActiveTime,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import { fetchItemDetailsAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import { withRouter } from 'react-router-dom';
import { getEmptyObjectforNull, validateFlagAndCallFunc, checkByParams } from 'common/utilities/utils';

export const analyzeFoodLine = (itemId, menuJSONData, currencyConversionFactor, selectedProduct, selectedProductId) => {
  let mapToReturn = {
    toRemove: true,
    requireModification: false,
    findings: ['Item not available'],
    menuPrice: undefined,
    newFoodLineItem: {
      item: {
        dname: selectedProduct?.productName,
        imageName: selectedProduct?.productImage,
        id: selectedProductId,
      },
    },
    cartPrice: selectedProduct?.productPrice,
    isItemPriceSame: false,
  };
  const flatItem = menuJSONData?.[itemId];
  if (flatItem) {
    mapToReturn.findings = [];
    mapToReturn.toRemove = false;
    const { price = 0 } = flatItem?.availability?.[0] ?? {};
    let priceFromMenu = price / currencyConversionFactor;
    let cartPrice = selectedProduct.productPrice;
    if (priceFromMenu !== cartPrice) {
      mapToReturn.findings.push(`Item Price has changed Cart Price(${cartPrice}), Menu price(${priceFromMenu})`);
      mapToReturn.requireModification = true;
      mapToReturn.menuPrice = priceFromMenu;
      mapToReturn.cartPrice = cartPrice;
    } else {
      mapToReturn.menuPrice = priceFromMenu;
      mapToReturn.cartPrice = cartPrice;
      mapToReturn.isItemPriceSame = true; // RENDEV-14498 adding this condition if item price is same then add to cart should happen.
    }
  }
  return mapToReturn;
};

const ProductState = props => {
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { flatResponse: { itemMapById = {} } = {}, isLoading = false } = getEmptyObjectforNull(
    useSelector(({ menuReducer }) => menuReducer),
  );
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { CART_STATES_DATA, ADD_TO_CART_CLICK, MENU_URL } = START_ORDER_CONSTANTS;
  const { currencyConversionFactor, tenantId } = tenantReducer;
  const selectedProductId = userOrderState.productItemId;
  const selectedProduct = userOrderState.oldProduct;
  const categoryId = userOrderState.categoryId;
  const [unavailableItems, setUnavailableItems] = useState([]);
  const [priceChangedItems, setPriceChangedItems] = useState([]);
  const cartReducer = useSelector(data => data.cartReducer);
  const currentItemDetails = useSelector(({ menuReducer }) => menuReducer.currentItemDetails);
  const dispatch = useDispatch();
  useEffect(() => {
    userOrderStateDispatch({ type: CART_STATES_DATA, value: { showCartModal: true } });
    if (itemMapById && currencyConversionFactor && !isLoading) {
      if (selectedProductId) {
        let validationSummaryResult = analyzeFoodLine(
          selectedProductId,
          itemMapById,
          currencyConversionFactor,
          selectedProduct,
          selectedProductId,
        );
        let unavailables = [];
        validationSummaryResult.toRemove && unavailables.push(validationSummaryResult);
        setUnavailableItems(unavailables);
        let priceChanged = [];
        validationSummaryResult.requireModification && priceChanged.push(validationSummaryResult);
        setPriceChangedItems(priceChanged);
        /**
         * RENDEV-14498 adding this condition if item price is same then add to cart should happen.
         */
        const samePriceFlag = checkByParams(validationSummaryResult.isItemPriceSame, cartReducer.cartData.id);
        validateFlagAndCallFunc(samePriceFlag, confirmChangesHandler);
      } else {
        setUnavailableItems([]);
        setPriceChangedItems([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currencyConversionFactor, selectedProductId, JSON.stringify(itemMapById), isLoading, cartReducer.cartData.id]);

  useEffect(() => {
    if (currentItemDetails && categoryId) {
      //to set flag in cartReducer
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: true,
          categorySelected: categoryId,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItemDetails]);

  const confirmChangesHandler = () => {
    console.log('test');
    if (!unavailableItems.length) {
      if (userOrderState.customizable) {
        dispatch(
          fetchItemDetailsAction({
            tenantId: tenantId,
            catalogName: userOrderState.catalogs, //'KFCIndiaMenu_129_D_1001',
            itemId: selectedProductId,
          }),
        );
      } else {
        dispatch(
          addItemToCartAction(
            {
              params: {
                basketId: cartReducer?.cartData?.id,
              },
              tenantId: tenantId,
            },
            [{ Id: selectedProductId, categoryId: categoryId, quantity: 1, modGrps: [] }],
          ),
        );
        dispatch(setUserLastActiveTime(new Date()));
      }
    } else {
      userOrderState.fromPdpPage && gotoMenuPage();
    }
    userOrderStateDispatch({ type: CART_STATES_DATA, value: { showCartModal: false } });
    userOrderStateDispatch({
      type: ADD_TO_CART_CLICK,
      value: { addToCart: false },
    });
  };

  const discardChangesHandler = () => {
    userOrderStateDispatch({ type: CART_STATES_DATA, value: { showCartModal: false } });
    userOrderStateDispatch({
      type: ADD_TO_CART_CLICK,
      value: { addToCart: false },
    });
    userOrderState.fromPdpPage && gotoMenuPage();
  };

  const gotoMenuPage = () => {
    props.history.push({
      pathname: `${MENU_URL}`,
    });
  };

  return (
    <React.Fragment>
      {userOrderState.cartStateData.showCartState && (unavailableItems.length || priceChangedItems.length) && (
        <ProductStatesModule
          data-testid='productStatesModule'
          unavailableItems={unavailableItems}
          priceChangedItems={priceChangedItems}
          confirmChangesHandler={confirmChangesHandler}
          discardChangesHandler={discardChangesHandler}
        />
      )}
    </React.Fragment>
  );
};

ProductState.propTypes = {};

ProductState.defaultProps = {};

export default withRouter(ProductState);
